module.exports = __webpack_public_path__ + "img/example-chat-output.81e72a4d.png";